import { EmptyEdgePropsSchema } from '../../graph-schemas/edges/common';
import type { EdgeDefinition } from './base-crm';

export const MARKETING_EDGES: Record<string, EdgeDefinition> = {
  MEMBER_OF: {
    type: 'MEMBER_OF',
    schema: EmptyEdgePropsSchema,
    displayName: 'Member Of',
    reverseDisplayName: 'Has Member',
    sourceTypes: ['Person'],
    targetTypes: ['Campaign'],
    props: [],
  },
  REGISTERED_FOR: {
    type: 'REGISTERED_FOR',
    schema: EmptyEdgePropsSchema,
    displayName: 'Registered For',
    reverseDisplayName: 'Has Registrant',
    sourceTypes: ['Person'],
    targetTypes: ['Event'],
    props: [{ key: 'status', label: 'Status', type: 'select', options: ['registered', 'attended', 'no_show'] }],
  },
  PART_OF: {
    type: 'PART_OF',
    schema: EmptyEdgePropsSchema,
    displayName: 'Part Of',
    reverseDisplayName: 'Includes',
    sourceTypes: ['Event'],
    targetTypes: ['Campaign'],
    props: [],
  },
};
